<template>
    <div class="main">
        <c-panel title="HISTÓRICO DE ALTERAÇÕES" titleIcon="fas fa-history">
            <el-alert
                title="Lista as últimas alterações registradas em entidades críticas do sistema. A gravação é manual via AuditService::log — entidades sem Observer ainda não aparecem aqui automaticamente."
                type="info" :closable="false" class="u-mb-15"></el-alert>

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :sm="6">
                        <el-form-item label="Tipo da entidade (model)">
                            <el-input v-model="filtro.auditable_type" placeholder="Ex.: App\Models\Aluno"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="4">
                        <el-form-item label="ID da entidade">
                            <el-input v-model.number="filtro.auditable_id" placeholder="123"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="4">
                        <el-form-item label="Ação">
                            <el-select v-model="filtro.action" clearable style="width:100%;">
                                <el-option value="created" label="CREATED"></el-option>
                                <el-option value="updated" label="UPDATED"></el-option>
                                <el-option value="deleted" label="DELETED"></el-option>
                                <el-option value="login" label="LOGIN"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="10" style="padding-top:24px;">
                        <el-button type="primary" @click="load" icon="el-icon-search">FILTRAR</el-button>
                        <el-button @click="resetar">LIMPAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <table class="table table-striped">
                <thead><tr>
                    <th style="width:140px;">Quando</th>
                    <th style="width:130px;">Usuário</th>
                    <th>Entidade</th>
                    <th style="width:100px;">Ação</th>
                    <th>Mudança</th>
                    <th style="width:130px;">IP</th>
                </tr></thead>
                <tbody>
                    <tr v-for="a in items" :key="a.id">
                        <td>{{ a.created_at | dt }}</td>
                        <td>{{ a.user_nome || (a.user ? a.user.name : '—') }}</td>
                        <td><code>{{ shortType(a.auditable_type) }}#{{ a.auditable_id }}</code></td>
                        <td><el-tag size="mini" :type="tagAcao(a.action)">{{ a.action }}</el-tag></td>
                        <td>{{ resumoMudanca(a) }}</td>
                        <td><small>{{ a.ip || '—' }}</small></td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="6" class="u-text-center" style="color:#909399;padding:20px;">Nenhum registro.</td>
                    </tr>
                </tbody>
            </table>

            <el-pagination
                v-if="meta.total > meta.per_page"
                background layout="prev, pager, next, total"
                :total="meta.total"
                :page-size="meta.per_page"
                :current-page.sync="paginaAtual"
                @current-change="load">
            </el-pagination>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { dt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm:ss') : '' } },
    data () {
        return {
            items: [],
            filtro: { auditable_type: '', auditable_id: null, action: '' },
            meta: { total: 0, per_page: 50 },
            paginaAtual: 1
        }
    },
    mounted () { this.load() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },

        shortType (t) { return t ? t.split('\\').pop() : '?' },

        tagAcao (a) {
            return { created: 'success', updated: 'warning', deleted: 'danger', login: 'info' }[a] || ''
        },

        resumoMudanca (a) {
            const oldV = a.old_values || {}
            const newV = a.new_values || {}
            const keys = Object.keys(newV).length ? Object.keys(newV) : Object.keys(oldV)
            if (!keys.length) return '—'
            return keys.slice(0, 3).map(k => {
                const o = oldV[k] !== undefined ? String(oldV[k]).slice(0, 20) : '∅'
                const n = newV[k] !== undefined ? String(newV[k]).slice(0, 20) : '∅'
                return `${k}: ${o} → ${n}`
            }).join(' · ')
        },

        load () {
            this.$axios.post(`${this.baseUrl()}/api/audit/getAllPaginate?page=${this.paginaAtual}`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(r => {
                    const d = r.data || {}
                    this.items = d.data || []
                    this.meta = { total: d.total || 0, per_page: d.per_page || 50 }
                })
                .catch(e => this.$store.commit('throwException', e))
        },

        resetar () {
            this.filtro = { auditable_type: '', auditable_id: null, action: '' }
            this.paginaAtual = 1
            this.load()
        }
    }
}
</script>
